// LoginPage: login form using AuthContext
import { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import AlertMessage from "../components/AlertMessage";

export default function LoginPage() {
  const navigate = useNavigate();
  const { login, isAuthenticated } = useAuth();
  const [form, setForm] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  // Redirect if already authenticated
  useEffect(() => {
    if (isAuthenticated) {
      navigate("/tours", { replace: true });
    }
  }, [isAuthenticated, navigate]);

  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setIsLoading(true);

    const result = await login(form);
    setIsLoading(false);

    if (result.success) {
      setTimeout(() => {
        navigate("/tours");
      }, 500);
    } else {
      setError(result.error || "Login failed");
    }
  };

  return (
    <div className="mx-auto w-full max-w-md">
      <h1 className="mb-4 text-2xl font-bold">Login</h1>
      {error && (
        <div className="mb-3">
          <AlertMessage type="error">{error}</AlertMessage>
        </div>
      )}
      <form
        onSubmit={handleSubmit}
        className="space-y-3 rounded-xl border border-slate-200 p-4 dark:border-slate-800"
      >
        <input
          name="email"
          type="email"
          value={form.email}
          onChange={handleChange}
          placeholder="Email"
          required
          className="w-full rounded-md border border-slate-300 px-3 py-2 text-sm dark:border-slate-700 dark:bg-slate-800 dark:text-slate-100"
        />
        <input
          name="password"
          type="password"
          value={form.password}
          onChange={handleChange}
          placeholder="Password"
          required
          className="w-full rounded-md border border-slate-300 px-3 py-2 text-sm dark:border-slate-700 dark:bg-slate-800 dark:text-slate-100"
        />

        <button
          type="submit"
          disabled={isLoading}
          className="w-full rounded-md bg-emerald-600 px-4 py-2 font-medium text-white hover:bg-emerald-700 disabled:opacity-50 disabled:cursor-not-allowed transition duration-200"
        >
          {isLoading ? "Logging in..." : "Log In"}
        </button>
      </form>
      <p className="mt-3 text-sm text-slate-600 dark:text-slate-300">
        Don't have an account?{" "}
        <Link to="/register" className="text-emerald-600 hover:underline">
          Create an account
        </Link>
      </p>
    </div>
  );
}
